import { Button, Sidebar, SortArrows } from "@rio-cloud/rio-uikit";
import { CheckpointStep, CheckpointStop, StageCheckpointStop } from "@types";
import { formatTimeFromMinutes, formatCheckpointStopDateTime } from "@utils";
import classNames from "classnames";

interface TableProps {
    cols: string[];
    type: 'size' | 'time';
    onClickItemInfo?: (step: CheckpointStep) => void;
    steps?: CheckpointStop['steps'];
    total: {
        realized: number;
        estimated: number;
    }
}

interface Props {
    open: boolean;
    onClose: () => void;
    onClickItemInfo?: (step: CheckpointStep) => void;
    data?: CheckpointStop;
}

const Table = ({ cols, type, onClickItemInfo, steps, total }: TableProps) => {
    const tableHeadClassNames = classNames("user-select-none", "sort-column");

    return (
        <div className="table-responsive">
            <table className="table table-head-filled table-bordered table-sticky bg-highlight-lighter">
                <thead>
                    <tr>
                        {cols.map((col, idx) => {
                            return (
                                <th className={tableHeadClassNames} key={col}>
                                    <span>
                                        <SortArrows />
                                        <span>{col}</span>
                                    </span>
                                </th>
                            )
                        })}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                  {steps?.map((step, idx) => {
                      return (
                          <tr
                              key={step.id}
                              className="height-60"
                          >
                              <td>
                                  <span className="text-normal text-size-14 text-color-map-marker-asset text-capitalize underline-offset-2">{idx + 1}.{step.title}</span>
                              </td>
                              <td>
                                  <span className="text-normal text-size-14 text-color-gray">{formatTimeFromMinutes(step.estimatedTimeMinutes)}</span>
                              </td>
                              <td>
                                  <div className="display-flex align-items-center gap-5">
                                      {type === 'time' ? <span className="rioglyph rioglyph-time text-size-14 text-color-gray"></span> : null}
                                      <span className="text-normal text-size-14 text-color-map-marker-asset">{formatTimeFromMinutes(step.realizedTimeMinutes)}</span>
                                  </div>
                              </td>
                              <td>
                                {step?.fields?.length ? (
                                    <Button
                                        onClick={() => onClickItemInfo?.({
                                            ...step,
                                            index: idx + 1,
                                        })}
                                        bsStyle={Button.PRIMARY}
                                        iconOnly
                                        iconName='rioglyph rioglyph-info-sign'
                                        className="bg-primary"
                                        variant={Button.VARIANT_LINK}
                                    />
                                ) : null}
                              </td>
                          </tr>
                      )
                  })}
                  <tr className="height-60 bg-highlight-lightest">
                      <td>
                          <span className="text-normal text-size-14 text-color-map-marker-asset text-bold">Tempo total</span>
                      </td>
                      <td>
                          <span className="text-normal text-size-14 text-color-gray">
                              {formatTimeFromMinutes(total.estimated)}
                          </span>
                      </td>
                      <td>
                          <div className="display-flex align-items-center gap-5">
                              {type === 'time' ? <span className="rioglyph rioglyph-time text-size-14 text-color-gray"></span> : null}
                              {/* <span className="text-normal text-size-14 text-color-map-marker-asset">{String(steps?.reduce((total, res) => total + (res.updatedAt || 0), 0))} min</span> */}
                              <span className="text-normal text-size-14 text-color-map-marker-asset">{formatTimeFromMinutes(total.realized)}</span>
                          </div>
                      </td>
                      <td />
                  </tr>
                </tbody>
            </table>
        </div>
    )
}

const SidebarCheckpoint = ({ onClose, onClickItemInfo, open, data }: Props) => {
    return (
        <Sidebar
            title="Checklist de parada"
            className="bg-lighter text-size-bold"
            headerClassName="text-size-bold padding-x-15 padding-bottom-0"
            closed={open}
            onClose={onClose}
            position={Sidebar.RIGHT}
            width={520}
            bodyClassName="padding-x-20 height-100pct"
        >
            <div className="gap-15 display-flex flex-column">
              <div className="display-flex flex-column gap-2">
                <div className="display-flex align-items-baseline">
                  <p className="text-size-16 text-bold margin-0">Data e hora da parada: </p>
                  <p className="text-size-16 text-medium margin-0 margin-left-5">{formatCheckpointStopDateTime(data)}</p>
                </div>
                <div className="display-flex align-items-baseline">
                  <p className="text-size-16 text-bold margin-0">Local: </p>
                  <p className="text-size-16 text-medium margin-0 margin-left-5">{data?.address || "---"}</p>
                </div>
              </div>
                <div className="display-flex align-items-center">
                    <div className="width-100pct">
                        <label htmlFor="input5">{data?.name}</label>
                        <div className="input-group gap-15">
                            <span className="input-group-addon">
                                <span className={'rioglyph rioglyph-pushpin'} />
                            </span>
                            <input id="input5" className="form-control" type="text" placeholder="" disabled value={data?.title} />
                        </div>
                    </div>
                </div>
                <div className="height-100pct display-flex flex-column gap-15">
                    <Table
                        cols={['Etapa', 'Planejado', 'Realizado']}
                        type="time"
                        onClickItemInfo={onClickItemInfo}
                        steps={data?.steps}
                        total={{
                            estimated: data?.estimatedTimeMinutes || 0,
                            realized: data?.realizedTimeMinutes || 0,
                        }}
                    />
                </div>
                <Button className="width-100pct height-40 align-self-end" onClick={onClose}>Voltar</Button>
            </div>
        </Sidebar>
    )
}

export default SidebarCheckpoint